var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreditCardConvert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6667 6.55438V4.10163C11.6667 1.83614 9.57353 0 7 0C4.42647 0 2.33333 1.83614 2.33333 4.10163V6.55438C0.952205 7.16186 0 8.39966 0 9.84299V12.3049C0 14.342 1.88726 16 4.19914 16H9.80086C12.117 16 14 14.342 14 12.3049V9.84299C14 8.39966 13.0478 7.15729 11.6667 6.55438ZM7.93076 11.4873C7.93076 11.9395 7.51042 12.3094 6.99571 12.3094C6.48101 12.3094 6.06066 11.9395 6.06066 11.4873V10.6651C6.06066 10.213 6.48101 9.84299 6.99571 9.84299C7.51042 9.84299 7.93076 10.213 7.93076 10.6651V11.4873ZM9.79657 6.15244H4.19485V4.10163C4.19485 2.74964 5.45588 1.63974 6.99571 1.63974C8.53554 1.63974 9.79657 2.74964 9.79657 4.10163V6.15244Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCardConvert);
export default __webpack_public_path__ + "static/media/credit-card-convert.154f1ba4e6a3e47cb07f72104a004847.svg";
export { ForwardRef as ReactComponent };